import { Col, Row, Breadcrumb, Select, MenuProps, Dropdown, Button } from "antd";
import Title from "../UI/Title/Title";
import { useLocation, useNavigate } from "react-router";
import InventoryList from "./inventoryList";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { getItemsApi } from "../../api/itemapi";
import { getCategoryDrpdown } from "../../api/category";
import { Link } from "react-router-dom";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { getSupplierDropdown } from "../../api/supplier";
import { getItemUnitDropdown } from "../../api/itemUnit";
import { getBrandDropdown } from "../../api/brand";
import { getPriceSchemeDropdown } from "../../api/pricescheme";
import { Search } from "../UI/Search/Search";
import { FilterInput } from "../UI/FilterApi/filterapi";
import FileDownloader from "./FileDownloader";
import FileUploader from "./FileUploader";
import { CaretDownOutlined } from "@ant-design/icons";

const Inventory = () => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const [formatedcategory, setFormatedcategory] = useState<{}[]>();
  const [formatedCategory, setFormatedCategory] = useState<{}[]>();
  const [formatedItemUnit, setFormatedItemUnit] = useState<{}[]>();
  const [formatedBrand, setFormatedBrand] = useState<{}[]>();
  const [formatedSupplier, setFormatedSupplier] = useState<{}[]>();
  const [formatedPriceScheme, setFormatedPriceScheme] = useState<{}[]>();
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedItems, setPaginatedItems] = useState([]);
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");
  const [initialValues, setInitialValues] = useState({ isActive: undefined });
  const location = useLocation();
  const q = location?.state?.q;
  const [selectedCategory, setSelectedCategory] = useState(null);
  useEffect(() => {
    setSelectedCategory(q);
  }, [q]);

  const resetFilters = () => {
    getItems({
      limit: page * 10 + 10,
      q: "",
      isChild: false,
    }).then((res) => {
      setPaginatedItems(res.data?.data);
      getCategoryDrpdown()
      setSearch("");
      setFilter(undefined);
      setSelectedCategory(q);
      setTableKey((tableKey) => tableKey + 1);
      setPage(1);
    });
  };

  const handleSearch = () => {
    getItems({
      limit: page * 10 + 10,
      q: search,
      isActive: filter,
      isChild: false,
    }).then((res: any) => {
      setPaginatedItems(res.data?.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getItems({
      limit: page * 10 + 10,
      q: "",
      isActive: isActive,
      isChild: false,
    }).then((res: any) => {
      setPaginatedItems(res.data?.data);
    });
  };

  const getItems = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
    isChild: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await ItemsMutation(params);
  };

  const { mutateAsync: ItemsMutation, isLoading: isItemsLoading } = useMutation(
    "items",
    getItemsApi
  );

  const { isLoading: loadingcategory } = useQuery(
    "categories",
    getCategoryDrpdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        // console.log('res.data', res.data)
        setFormatedcategory(
          res.data
            .map((category: any) => {
              if (category.isActive) {
                return {
                  value: category.id,
                  label: category.name,
                };
              } else {
                return null;
              }
            })
            .filter((category: any) => category !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ isActive: res.data[0].id });
        }
      },
    }
  );

  const { isLoading: loadingItemUnit } = useQuery(
    "ItemUnit",
    getItemUnitDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedItemUnit(
          res.data
            ?.map((unit: any) => {
              if (unit.isActive) {
                return { value: unit.id, label: unit.name };
              } else {
                return null;
              }
            })
            .filter((unit: any) => unit !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ isActive: res.data[0].id });
        }
      },
    }
  );

  const { isLoading: loadingBrand } = useQuery("brands", getBrandDropdown, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setFormatedBrand(
        res.data
          .map((brand: any) => {
            if (brand.isActive) {
              return { value: brand.id, label: brand.name };
            } else {
              return null;
            }
          })
          .filter((brand: any) => brand !== null)
      );
      if (res.data.length > 0) {
        setInitialValues({ isActive: res.data[0].id });
      }
    },
  });

  const { isLoading: loadingSupplier } = useQuery(
    "suppliers",
    getSupplierDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedSupplier(
          res.data
            .map((supplier: any) => {
              if (supplier.isActive) {
                return { value: supplier.id, label: supplier.name };
              } else {
                return null;
              }
            })
            .filter((supplier: any) => supplier !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ isActive: res.data[0].id });
        }
      },
    }
  );

  const { isLoading: loadingPriceScheme } = useQuery(
    "PriceScheme",
    getPriceSchemeDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedPriceScheme(
          res.data
            .map((price: any) => {
              if (price.isActive) {
                return { value: price.id, label: price.name };
              } else {
                return null;
              }
            })
            .filter((price: any) => price !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ isActive: res.data[0].id });
        }
      },
    }
  );

  /*select category */

  const { isLoading: loadingCategory } = useQuery(
    "categories",
    getCategoryDrpdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedCategory(
          res.data.map((category: any) => {
            return {
              value: category.id,
              label: category.name,
            };
          })
        );
      },
    }
  );

  const baseURL = (window as any).REACT_APP_BASE_API_URL

  const items: MenuProps["items"] = [
    {
      label: (
        <FileDownloader fileName={'Sheet Items'} btnName={t('download')} link={baseURL + `/items/template`} />
      ),
      key: "1",
    },
    {
      label: (
        <FileUploader
          btnName={t('upload')}
          uploadUrl={baseURL + `/items/bulk-import`}
          resetFilters={resetFilters}
        />
      ),
      key: "2",
    },
  ];
  const menuProps = {
    items,
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("inventory")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">{t("items-list")}</span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          {/* <Title title={`${t("items-list")}`} /> */}
        </Col>

        <Col offset={1} span={4}>
          <Select
            key={tableKey}
            size="large"
            style={{ width: "100%" }}
            placeholder={`${t("select-category")}`}
            loading={loadingCategory}
            options={formatedCategory}
            showSearch={true}
            optionFilterProp="label"
            value={selectedCategory} // Set the selected value
            onChange={(value) => setSelectedCategory(value)} // Update the selected value when changed
          />
        </Col>

        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
            onEnter={() => {
              handleSearch();
            }}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>

        <Col
          offset={10}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <ResetButton
            onClick={() => {
              resetFilters();
            }}
          />
          <AddButton
            onClick={() => {
              navigate(`/item/create`, {
                state: {
                  formatedBrand: formatedBrand,
                  loadingBrand: loadingBrand,
                  formatedItemUnit: formatedItemUnit,
                  loadingItemUnit: loadingItemUnit,
                  formatedPriceScheme: formatedPriceScheme,
                  loadingPriceScheme: loadingPriceScheme,
                  formatedSupplier: formatedSupplier,
                  loadingSupplier: loadingSupplier,
                  formatedcategory: formatedcategory,
                  loadingcategory: loadingcategory,
                  initialValues: initialValues,
                },
              });
            }}
          />
          <Dropdown trigger={["click"]} menu={menuProps}>
            <Button
              type="primary"
              style={{ background: "#1677FF", color: "#fff", height: "40px" }}
            >
              <CaretDownOutlined />
              {t("action")}
            </Button>
          </Dropdown>
        </Col>
        <Col span={22} offset={1}>
          <InventoryList
            ItemsMutation={ItemsMutation}
            isItemsLoading={isItemsLoading}
            page={page}
            setPage={setPage}
            filter={filter}
            search={search}
            paginatedItems={paginatedItems}
            setPaginatedItems={setPaginatedItems}
            selectedCategory={selectedCategory}
            tableKey={tableKey}
          />
        </Col>
      </Row>
    </>
  );
};

export default Inventory;
